import React, { useEffect, useState } from "react";
import client, { mediaUrl } from "../lib/api";
import Layout, { PageHero } from "../components/site/Layout";
import { SectionTitle, Reveal, Eyebrow } from "../components/site/common";
import { ABOUT_PARAGRAPHS, VISION, MISSION, OBJECTIVES, TRUST, PHOTOS } from "../lib/data";

export default function About() {
  const [leaders, setLeaders] = useState([]);
  useEffect(() => { client.get("/public/leadership").then(({ data }) => setLeaders(data)).catch(() => {}); }, []);

  return (
    <Layout>
      <PageHero eyebrow="About Us" title="A legacy of service since 1995." intro="Rooted in faith, service and community responsibility in Tiruchirappalli, Tamil Nadu." />

      <section className="mx-auto max-w-7xl px-5 py-20 lg:px-10 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="space-y-5 lg:col-span-7">
            {ABOUT_PARAGRAPHS.map((p, i) => (
              <p key={i} className="text-base leading-relaxed text-ink-muted lg:text-lg">{p}</p>
            ))}
          </div>
          <div className="lg:col-span-5">
            <div className="aspect-[4/5] overflow-hidden border border-gold/30">
              <img src={PHOTOS.service} alt="Community service" className="h-full w-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="bg-white border-y border-gold/20">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 py-20 lg:grid-cols-2 lg:gap-16 lg:px-10">
          <Reveal>
            <Eyebrow>Our Vision</Eyebrow>
            <p className="mt-5 font-serif text-2xl leading-snug text-maroon lg:text-3xl">{VISION}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <Eyebrow>Our Mission</Eyebrow>
            <p className="mt-5 text-base leading-relaxed text-ink-muted lg:text-lg">{MISSION}</p>
          </Reveal>
        </div>
      </section>

      {/* Objectives */}
      <section className="mx-auto max-w-7xl px-5 py-20 lg:px-10 lg:py-24">
        <SectionTitle eyebrow="Our Objectives" title="Ten commitments that guide our work" />
        <div className="mt-12 grid gap-x-12 gap-y-8 md:grid-cols-2">
          {OBJECTIVES.map(([title, desc], i) => (
            <Reveal key={title} delay={(i % 2) * 0.05}>
              <div className="flex gap-5 border-t border-gold/20 pt-6">
                <span className="font-serif text-2xl text-gold">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <h3 className="text-lg font-medium text-maroon">{title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink-muted">{desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Leadership */}
      <section className="bg-ivory-dark/40">
        <div className="mx-auto max-w-7xl px-5 py-20 lg:px-10 lg:py-24">
          <SectionTitle eyebrow="Leadership" title="Guided by dedicated stewardship" />
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:max-w-3xl">
            {leaders.map((l) => (
              <div key={l.id} className="border border-gold/20 bg-white p-8" data-testid={`leader-${l.id}`}>
                {l.photo
                  ? <img src={mediaUrl(l.photo)} alt={l.name} className="mb-4 h-14 w-14 rounded-full border border-gold/40 object-cover" />
                  : <div className="mb-4 h-14 w-14 rounded-full border border-gold/40 bg-ivory" />}
                <h3 className="text-xl font-medium text-maroon">{l.name}</h3>
                <p className="mt-1 text-xs uppercase tracking-[0.15em] text-gold-dark">{l.position}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Registration */}
      <section className="mx-auto max-w-7xl px-5 py-20 lg:px-10">
        <SectionTitle eyebrow="Registration" title="Official particulars" />
        <div className="mt-10 grid gap-x-12 gap-y-6 border-t border-gold/20 pt-8 sm:grid-cols-2 lg:grid-cols-3">
          {[
            ["Established", TRUST.established], ["Registration Number", TRUST.regNumber],
            ["Registration Act", TRUST.regAct], ["Registration Authority", TRUST.regAuthority],
            ["Date of Registration", TRUST.regDate], ["Registration City", TRUST.regCity],
            ["State", TRUST.state], ["Organization Type", TRUST.orgType],
            ["DARPAN ID", TRUST.darpanId], ["DARPAN Registration Date", TRUST.darpanDate],
          ].map(([k, v]) => (
            <div key={k}>
              <div className="text-xs uppercase tracking-[0.15em] text-ink-muted">{k}</div>
              <div className="mt-1 text-base text-maroon">{v}</div>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
